import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "fullSearch",
  initialState: false,
  reducers: {
    setFullSearch: (state, action) => action.payload,
  },
});

export const { setFullSearch } = slice.actions;
export default slice.reducer;
